import * as actionTypes from "../../constants/actionTypes";
import * as handlers from "../../constants/handlers";
import * as resultCodes from "../../constants/resultCodes";
import * as methods from "../../constants/methods";
import * as messageHelper from "../../helpers/messageHelper";
import * as responseHelper from "../../helpers/responseHelper";
import * as settingsHelper from "../../helpers/settingsHelper";

export const processWebsocketResponse = (tabId, method, response, state) => {
    switch (method) {
        case handlers.SEARCH_GLOBAL_FORMULAS:
            if (!responseHelper.isFormulaListFormatValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            return [
                {
                    type: actionTypes.SAVE_FORMULA_LIST,
                    payload: {
                        formulaList: response.data.colorList,
                        formulaCount: response.data.colorCount,
                        customGlobalSearch: state.navigation.customGlobalSearch
                    }
                }
            ];
        case handlers.SEARCH_GLOBAL_FORMULAS_WITH_OFFSET:
            if (!responseHelper.isFormulaListFormatValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            return [
                {
                    type: actionTypes.RELOAD_FORMULA_LIST,
                    payload: {
                        formulaList: response.data.colorList
                    }
                }
            ];
        case handlers.RELOAD_ALL_COLORANTS:
            if (!responseHelper.isGetAllColorantsFormatValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            return [
                {
                    type: actionTypes.SAVE_COLORANT_LIST,
                    payload: {
                        colorantList: response.data.colorantList
                    }
                }
            ];
        case handlers.RELOAD_ALL_SERVER_COLORANTS:
            if (!responseHelper.isGetAllColorantsFormatValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            return [
                {
                    type: actionTypes.SAVE_ALL_COLORANT_LIST,
                    payload: {
                        colorantList: response.data.colorantList
                    }
                }
            ];
        case handlers.RELOAD_LAST_DISPENSED_FORMULAS:
            if (!responseHelper.isGetLastDispensedFormulasFormatValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            return [
                {
                    type: actionTypes.SAVE_LAST_DISPENSED_FORMULAS_WITH_OFFSET,
                    payload: {
                        lastDispensedList: response.data
                    }
                }
            ];
        case handlers.ENABLE_PRODUCT:
            if (response.result !== resultCodes.RESULT_OK) {
                return [messageHelper.getFlashMessage(response)];
            }

            return [
                {
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_GET_ALL_PRODUCTS,
                        params: {
                            tree: false
                        }
                    },
                    method: handlers.RELOAD_GLOBAL_ALL_PRODUCTS_SIMPLE,
                    tabId: 0
                },
                {
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_GET_DISABLED_PRODUCTS_STATUS
                    },
                    method: handlers.GET_DISABLED_PRODUCTS_STATUS,
                    tabId: 0
                }
            ];
        case handlers.RELOAD_GLOBAL_ALL_PRODUCTS:
            if (!responseHelper.isGroupListFormatValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            return [
                {
                    type: actionTypes.SAVE_PRODUCT_LIST,
                    payload: {
                        productList: response.data
                    }
                }
            ];
        case handlers.RELOAD_GLOBAL_ALL_PRODUCTS_SIMPLE:
            if (!responseHelper.isGetAllProductsSimpleFormatValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            return [
                {
                    type: actionTypes.SAVE_PRODUCT_SIMPLE_LIST,
                    payload: {
                        productList: response.data
                    }
                }
            ];
        case handlers.GET_DISABLED_PRODUCTS_STATUS:
            if (!responseHelper.isGetDisabledValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            return [
                {
                    type: actionTypes.SAVE_DISABLED_PRODUCTS,
                    payload: {
                        disabledProducts: response.data.numDisabledItems
                    }
                }
            ];
        case handlers.ENABLE_FANDECK:
            if (response.result !== resultCodes.RESULT_OK) {
                return [messageHelper.getFlashMessage(response)];
            }

            return [
                {
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_GET_ALL_FANDECKS
                    },
                    method: handlers.RELOAD_GLOBAL_ALL_FANDECKS,
                    tabId: 0
                },
                {
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_GET_DISABLED_FANDECKS_STATUS
                    },
                    method: handlers.GET_DISABLED_FANDECKS_STATUS,
                    tabId: 0
                }
            ];
        case handlers.RELOAD_GLOBAL_ALL_FANDECKS:
            if (!responseHelper.isGetAllFandecksFormatValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            return [
                {
                    type: actionTypes.SAVE_FANDECK_LIST,
                    payload: {
                        fandeckList: response.data.fandeckList
                    }
                }
            ];
        case handlers.GET_DISABLED_FANDECKS_STATUS:
            if (!responseHelper.isGetDisabledValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            return [
                {
                    type: actionTypes.SAVE_DISABLED_FANDECKS,
                    payload: {
                        disabledFandecks: response.data.numDisabledItems
                    }
                }
            ];
        case handlers.GET_ALL_TINTOMETRIC_SYSTEMS:
            if (!responseHelper.isGetAllTintometricSystemsValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            return [
                {
                    type: actionTypes.SAVE_TINTOMETRIC_SYSTEM_LIST,
                    payload: {
                        tintometricSystemList: response.data
                    }
                }
            ];
        case handlers.GET_ACTIVE_TINTOMETRIC_SYSTEM:
            if (response.result !== resultCodes.RESULT_OK) {
                return [messageHelper.getFlashMessage(response)];
            }

            return [
                {
                    type: actionTypes.SAVE_TINTOMETRIC_SYSTEM,
                    payload: {
                        tintometricSystem: response.data
                    }
                }
            ];
        case handlers.GET_TINTOMETRIC_SYSTEM_ICON:
            if (response.result !== resultCodes.RESULT_OK) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            if (!responseHelper.isImageFormatValid(response)) {
                return [];
            }

            const tsImageRequest = state.server.requests.find((request) => request.id === response.sequence);

            if (tsImageRequest === undefined) {
                return [];
            }

            window.imageStore.addTsImage(tsImageRequest.next, {
                type: response.data.mimeType,
                img: response.data.data
            });

            return [
                {
                    type: actionTypes.IMAGE_STORE_UPDATE
                }
            ];
        case handlers.RELOAD_GLOBAL_INITIAL_DATA:
            if (response.result !== resultCodes.RESULT_OK || !responseHelper.isInitDataFormatValid(response.data)) {
                return [messageHelper.getFlashMessage(response)];
            }

            return responseHelper.handleGlobalInitDataResponse(response);
        case handlers.RELOAD_GLOBAL_PRICE_SETTINGS:
            if (!responseHelper.isGetUserSettingsFormatValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            return [
                {
                    type: actionTypes.SAVE_PRICE_SETTINGS,
                    payload: settingsHelper.parsePricingSettings(response.data)
                }
            ];
        case handlers.RELOAD_GLOBAL_GET_ALL_UNITS:
            if (!responseHelper.isGetAllUnitsFormatValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            return [
                {
                    type: actionTypes.SAVE_UNIT_LIST,
                    payload: {
                        unitList: response.data.units
                    }
                }
            ];
        default:
            return [
                {
                    type: actionTypes.UNKNOWN_ACTION
                }
            ];
    }
};
